import CtaButton, { CallToAction, CtaButtonProps } from './CtaButton'

export default CtaButton
export type { CtaButtonProps, CallToAction }
